<template>
	<div id="app">
		<!-- <Header></Header> -->
		<router-view />
	</div>
</template>

<script>
	import Header from "./components/Header";
	export default {
		name: 'App',
		components: {
			Header
		}
	}
</script>
<style>
	@import "./assets/css/common.css";
	html>body {
		margin: 0;
		height: auto;
	}

	#app {
		background: #EFF3F9;
	}
   a{
     text-decoration: none;
	 display: block;
   }
   
</style>
